export default {"src":"/_next/static/media/setting.5387eae7.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};